import { IWithContextProps, core, withContext } from '@tock/coretypes';
import { Typography } from 'omakase';
import { makeSigninLink } from 'components/sign-in/Signin';
import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';
import GuestInputForm from 'components/business/quick-checkout/GuestInputForm';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: any;
  isSubmitting: boolean;
  onValidatePhone?(isPhoneValid: boolean, smsPhoneConsentStatus: core.SmsPhone.StatusType): void;
}

class GuestInformation extends BaseComponent<Props & IWithContextProps> {
  render() {
    const {
      context,
      getPath,
      isSubmitting,
      onValidatePhone,
      fields: { patron },
    } = this.props;

    return (
      <div className="ConsumerCheckout-section">
        <h2 className="ConsumerCheckout--title">
          <Typography color="inherit" component="span" variant="body02Strong">
            Add your reservation details
          </Typography>
        </h2>
        <div className="ConsumerCheckout--subtitle">
          <Typography color="inherit" component="span" variant="body02">
            Already a Tock user?
            {` `}
            <Anchor
              className="u-activeColor u-link"
              href={getPath(
                makeSigninLink(
                  'login',
                  `${context.appContext?.pathPrefix}/checkout/complete-profile`
                )
              )}
            >
              Log in
            </Anchor>
            {` `}
            to skip this step, or
            {` `}
            <Anchor
              className="u-activeColor u-link"
              href={getPath(
                makeSigninLink(
                  'signup',
                  `${context.appContext?.pathPrefix}/checkout/complete-profile`
                )
              )}
            >
              Sign up
            </Anchor>
            {` `}
            to create an account.
            {` `}
          </Typography>
        </div>
        <GuestInputForm
          fields={patron}
          isSubmitting={isSubmitting}
          onValidatePhone={onValidatePhone}
        />
      </div>
    );
  }
}

export default withContext<Props>(GuestInformation);
